import { render, staticRenderFns } from "./ChangesCompose.vue?vue&type=template&id=eb60a67c"
import script from "./ChangesCompose.vue?vue&type=script&lang=js"
export * from "./ChangesCompose.vue?vue&type=script&lang=js"
import style0 from "./ChangesCompose.vue?vue&type=style&index=0&id=eb60a67c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports